const vpsvcRegExp = /^https?:\/\/(.+\.vpsvc\.com)/;
const localRegExp = /^https?:\/\/localhost(:\d+)?/;
const prodOrStagingRegExp =
  /^https?:\/\/((www|staging|next)\.)?(vistaprint|promotique)\..*/;
const vcsRegExp =
  /^https:\/\/[a-zA-Z0-9-]+(\.(dev|stage))?\.(ourproshop|proshopnext)\..*/;
const cepRegExp = /^https:\/\/[a-zA-Z0-9-]+\.experience\.cimpress\.io$/;

export const isTrustedOrigin = (origin) => {
  if (!origin) {
    return false;
  }

  return (
    origin.match(vpsvcRegExp) ||
    origin.match(localRegExp) ||
    origin.match(prodOrStagingRegExp) ||
    origin.match(vcsRegExp) ||
    origin.match(cepRegExp)
  );
};
